module.exports = __webpack_public_path__ + "static/media/badge-percent.24ccb3e8.svg";